import { megaethTestnet as viemMegaethTestnet } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const megaethTestnet = {
  displayName: 'MegaETH Testnet',
  runtime: 'evm',
  viemChain: viemMegaethTestnet,
  isSupported: false,
  isMainnet: false,
  services: defaultServices(),
} as const satisfies AllChainConfig<'evm', false>;
